// extracted by mini-css-extract-plugin
module.exports = {"InstructionItem":"AvailabilityInstructions_InstructionItem__2BdlB","ItemNumber":"AvailabilityInstructions_ItemNumber__1wUTI"};